import { Box, Button, Flex, Text, Textarea } from '@mantine/core';
import { useMemo } from 'react';
import { REPORT_NAMINGS } from '../../../../../consts/reportTypes';

export function AddAIFs({
  handleCreate,
  isLoading,
  selectedReportType,
  expression,
  setExpression
}) {
  const foundFunds = useMemo(() => {
    if (!expression) return [];

    return expression
      ?.split(/[\n,]+/) // Split on newlines OR commas (matches the placeholder text)
      ?.map(line => line.trim()) // Trim each entry to remove extra spaces
      ?.filter(line => line); // Filter out empty entries
  }, [expression]);

  return (
    <Box>
      <Textarea
        label={`${REPORT_NAMINGS.FUND[selectedReportType]} Names`}
        placeholder={`Add one or multiple ${REPORT_NAMINGS.FUND[selectedReportType]}s, separated by commas`}
        value={expression}
        onChange={e => setExpression(e.target.value)}
        resize="vertical"
        minRows={6}
        rows={6}
        maxRows={10}
      />
      <Box mt="16px">
        {foundFunds.map(item => (
          <Text fz="sm" mb="8px" key={item}>
            {item}
          </Text>
        ))}
      </Box>
      <Flex justify="flex-end" mt="48px">
        <Button loading={isLoading} onClick={() => handleCreate(foundFunds)}>
          Save {foundFunds.length > 0 && `(${foundFunds.length})`}
        </Button>
      </Flex>
    </Box>
  );
}
